import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { useSettings } from 'hooks/useSettings';

const PrintComponent = ({ firstName, lastName, appId }) => {
  const [loaded, setLoaded] = useState(false);
  const [printed, setPrinted] = useState(false);

  const {
    lang: { code, langFile },
  } = useSettings();
  // eslint-disable-next-line max-len
  const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}&lang=${langFile}_${langFile
    .replace('pt', 'br')
    .replace('ko', 'kr')
    .toUpperCase()}`;

  useEffect(() => {
    if (loaded && !printed) {
      // Adding a timeout to ensure the print action happens after the image is fully rendered
      setTimeout(() => {
        window.print();
        setPrinted(true);
      }, 500); // You may adjust this timeout value
    }
  }, [loaded, printed]);

  return (
    <div>
      <div
        style={{
          backgroundColor: '#FFF',
          width: '100%',
          height: '100%',
          position: 'absolute',
        }}
        id="printCover"
      />
      <img src={image} alt={`${firstName} ${lastName}`} width="100%" height="auto" onLoad={() => setLoaded(true)} />
      {printed && <Redirect to="/main/training" />}
    </div>
  );
};

PrintComponent.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  appId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PrintComponent;
